import React from 'react';

export const courseSections = [
  {
    id: 'be-smart',
    title: 'BE SMART',
    subtitle: 'SE STUDI O LAVORI IN SMART … SEMPRE A TESTA ALTA!',
    description:
      'BE SMART è il manuale che ho preparato per chi studia o lavora "in smart" che salva la schiena, un sacco di soldi e anche il futuro!',
    image: 'be-smart.jpg',
    price: '€74,00',
    discountNote:
      "Nella mail di conferma dell'acquisto riceverai il CODICE SCONTO di €10,00 per l'acquisto della tua Valutazione Posturale (anche on line!)",
    features: {
      title: '',
      items: [
        'Oltre 60 preziosissimi suggerimenti',
        '27 esercizi pratici, spiegati con parole semplici',
        '15 video esplicativi',
        '3 tracce audio guidate',
        'Consigli PRIMA e POI',
      ],
    },
    exclusiveContent:
      'Contiene un capitolo interamente dedicato a rivelarti qual è la SMART SKILL che assolutamente devi fare tua per assicurarti un futuro di BENESSERE anche se studi o lavori "in smart"',
    exclusiveCta: 'Clicca subito qui',
    freeResources: [
      { icon: '📄', title: 'Il pdf del Capitolo 1' },
      { icon: '📺', title: 'Guarda subito il Video n. 1' },
      {
        icon: '🎬',
        title:
          'Guarda subito il Video n. 2 "Imparare a respirare bene caccia via lo STRESS"',
      },
      {
        icon: '🔊',
        title: 'Ascolta la traccia n. 1 "5 minuti di Coerenza Cardiaca"',
      },
    ],
    ctaButtons: {
      primary: {
        text: 'AGGIUNGI AL CARRELLO',
        action: () => (window.location.href = '/carrello?course=be-smart'),
      },
      secondary: {
        text: 'CONTATTAMI SUBITO',
        action: () =>
          (window.location.href = '/contatti?service=personal-coaching'),
      },
    },
  },
  {
    id: 'be-xpert',
    title: 'BE XPERT',
    subtitle: 'PRIMA DI SCEGLIERE DI ALLENARTI A CASA',
    description:
      "Questo manuale è un'ENCICLOPEDIA DEL BENESSERE POSTURALE che ciascuno dovrebbe ricevere come dono il giorno della nascita. Contiene le ISTRUZIONI PER L'USO consapevole del corpo.",
    comingSoon: true,
    additionalContent: (
      <div>
        <div className="mb-4">
          <h4 className="fw-bold mb-3 text-center">
            Un condensato di istruzioni ed esercizi pratici{' '}
            <span className="text-primary">INDISPENSABILI</span> per compiere
            con disinvoltura ogni movimento:
          </h4>

          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="features-list-no-image mb-4">
                <div className="feature-item-no-image mb-4">
                  <h5 className="fw-bold text-primary mb-2">
                    <span className="feature-number me-2">1.</span>
                    PRIMA di muoversi
                  </h5>
                  <p className="mb-0 ps-4">
                    per comprendere come impostare il corretto allineamento del
                    corpo in base alla finalità del movimento che si intende
                    compiere
                  </p>
                </div>

                <div className="feature-item-no-image mb-4">
                  <h5 className="fw-bold text-primary mb-2">
                    <span className="feature-number me-2">2.</span>
                    DURANTE il movimento
                  </h5>
                  <p className="mb-0 ps-4">
                    per sentire e controllare i muscoli che si devono attivare
                    correttamente ed evitare di utilizzare o di mettere in
                    posizioni errate articolazioni o muscoli che potrebbero
                    subire danni e procurare dolori anche seri
                  </p>
                </div>

                <div className="feature-item-no-image mb-4">
                  <h5 className="fw-bold text-primary mb-2">
                    <span className="feature-number me-2">3.</span>
                    DOPO il movimento
                  </h5>
                  <p className="mb-0 ps-4">
                    per trovare ristoro e dare sollievo a tutto il corpo,
                    imparando a prendersi cura amorevolmente di se, anche di
                    quelle parti invisibili agli occhi, ma essenziali per il
                    nostro benessere a lungo e lunghissimo termine.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mb-5">
          <p className="mb-4" style={{ fontSize: '1.05rem' }}>
            <strong>Grazie al video di BE XPERT</strong> riceverai tante
            informazioni dettagliate, come nessun altro ti ha mai spiegato
            prima, con parole semplici, che ti guideranno passo, passo a sentire
            ogni muscolo che è necessario attivare per compiere il movimento che
            intendi fare, integrando la respirazione correttamente.
          </p>
          <p className="mb-4" style={{ fontSize: '1.05rem' }}>
            Sarai in grado di isolare la parte del corpo che vuoi muovere da
            tutto il resto del corpo che vuoi mantenere in allineamento.
            Diventerai capace di controllare simultaneamente movimento, respiro
            e controllo.
          </p>
          <p className="mb-4" style={{ fontSize: '1.05rem' }}>
            <strong>
              In altre parole, capirai con l'esperienza diretta cosa significa
              realmente unire corpo e mente. Anzi, diventerai un'espert@!
            </strong>
          </p>
        </div>

        <div className="be-xpert-cta mb-5 text-center">
          <h4 className="fw-bold mb-3 text-primary">
            PRIMA di scegliere di allenarti a casa, BE XPERT!
          </h4>
          <p className="mb-4" style={{ fontSize: '1.05rem' }}>
            Se hai dovuto sospendere il tuo amato corso in palestra, perché
            improvvisamente ti si è bloccata la schiena o hai cominciato ad
            accusare dolori posturali, prova subito BE XPERT e rimettiti in
            movimento senza paura!
          </p>
        </div>
      </div>
    ),
    finalCta: 'DIVENTA CONSAPEVOLE DEL TUO MOVIMENTO CON BE XPERT …',
    finalHighlight: 'INIZIA SUBITO A VIVERE MEGLIO: VIVI A TESTA ALTA!',
  },
  {
    id: 'be-free',
    title: 'BE FREE',
    subtitle: 'LIBERA IL TUO RESPIRO, LIBERA LA TUA VITA',
    comingSoon: true,
    description:
      'Questo manuale è pensato per offrirti uno strumento potentissimo per liberarti dallo STRESS che, oltre a renderti la vita un inferno, ti carica di tensione, generando problemi a muscoli, articolazioni e perfino a degli organi compressi nella morsa dei muscoli irrigiditi, lasciandoti col fiato corto o senza respiro.',
    additionalContent: (
      <div className="additional-content">
        <div className="mb-4">
          <p className="mb-4" style={{ fontSize: '1.05rem' }}>
            <strong>
              IL DIAFRAMMA è il tuo potentissimo alleato! Ma sai come usarlo?
              Sai come e quando attivarlo?
            </strong>
          </p>
          <p className="mb-4" style={{ fontSize: '1.05rem' }}>
            Se sei già stat@ vittima dello STRESS, probabilmente il tuo
            diaframma è bloccato o irrigidito e non funziona a dovere. Ma allo
            stesso modo il diaframma potrebbe essere bloccato se hai
            sperimentato un trauma, come un incidente, una caduta molto forte,
            se hai delle preoccupazioni che ti occupano senza riposo la mente,
            oppure se hai subito traumi emotivi, come un lutto, una separazione,
            un trasloco …
          </p>
          <p className="mb-4" style={{ fontSize: '1.05rem' }}>
            Già che tutti possediamo il diaframma, tutti abbiamo il diritto di
            sapere come usare uno strumento così potente: attraverso la
            modulazione del movimento diaframmatico è possibile modificare il
            ritmo respiratorio e di conseguenza il ritmo del battito cardiaco.
          </p>
          <p className="mb-4" style={{ fontSize: '1.05rem' }}>
            Cioè, attraverso la modulazione di un muscolo volontario, ognuno di
            noi è in grado di modificare il ritmo del cuore che è un muscolo
            involontario!{' '}
            <strong>
              (Spoiler: questa si chiama Coerenza cardiaca ={'>'} clicca subito{' '}
              <a href="#" className="additional-content-cta-link">
                qui
              </a>{' '}
              e ascolta la traccia con la mia voce che ti guida durante "5
              minuti di Coerenza cardiaca")
            </strong>
          </p>
          <p className="mb-4" style={{ fontSize: '1.05rem' }}>
            Nei video allegati al manuale ti insegno passo, passo come fare!
          </p>
          <p className="mb-4" style={{ fontSize: '1.05rem' }}>
            Ma non mi limito solo al diaframma … con BE FREE imparerai a
            integrare il movimento del diaframma con altri importantissimi
            muscoli, fondamentali per il tuo BENESSERE POSTURALE. Liberare il
            tuo respiro ti darà il potere di gestire lo STRESS, cioè di decidere
            come reagire di fronte ad una situazione stressante, mantenendo il
            focus sulla tua INTERA postura, liberando anche il movimento.
          </p>
          <p className="mb-4" style={{ fontSize: '1.05rem' }}>
            Sono inclusi esercizi esclusivi e una visualizzazione guidata per
            purificarti dalle tossine emotive attraverso il respiro.
          </p>
        </div>
      </div>
    ),
    finalHighlight: 'INIZIA SUBITO A VIVERE MEGLIO: VIVI A TESTA ALTA!',
  },
  {
    id: 'be-strong',
    title: 'BE STRONG',
    subtitle: 'FOR WOMEN ONLY',
    comingSoon: true,
    forWomenOnly: true,
    description:
      'Non posso ancora rivelare dettagli, ma è una sorpresa tutta al femminile!',
    finalHighlight: 'PROSSIMAMENTE...',
  },
  {
    id: 'be-power',
    title: 'BE POWER',
    subtitle: 'FOR WOMEN ONLY',
    comingSoon: true,
    forWomenOnly: true,
    description:
      'Non posso ancora rivelare dettagli, ma è una sorpresa tutta al femminile!',
    finalHighlight: 'PROSSIMAMENTE...',
  },
  {
    id: 'be-you',
    title: 'BE YOU',
    subtitle: 'WORK IN PROGRESS',
    workInProgress: true,
    description: 'Stiamo lavorando a qualcosa di speciale per te...',
    finalHighlight: 'WORK IN PROGRESS...',
  },
];
